export const getStringFromFilters = (filters: Map<string, string>) => {
  const filtersArray = Array.from(filters.entries()).map(
    ([key, value]) => `${key}:${value}`,
  );

  const val = Buffer.from(filtersArray.join(',')).toString('base64');

  return val || null;
};
